// extracted by mini-css-extract-plugin
module.exports = {"start-date-container":"std-claim_start-date-container__ykX4s","icon":"std-claim_icon__3cbCu"};